module.exports = __webpack_public_path__ + "static/media/pencil.1eb3ade7.svg";